<div class="container">
  @if (loading()) {
    <app-progress-spinner [enabled]="loading()" />
  } @else {
    <label class="date-label">{{ 'CRM.LABEL.START_DATE' | translate }}: </label>
    <p-datepicker
      [showButtonBar]="true"
      [(ngModel)]="startDate"
      dateFormat="yy-mm-dd"
      appendTo="body"
    />
    <label class="date-label">{{ 'CRM.LABEL.END_DATE' | translate }}: </label>
    <p-datepicker
      [showButtonBar]="true"
      [(ngModel)]="endDate"
      dateFormat="yy-mm-dd"
      [minDate]="startDate()"
      appendTo="body"
    />
    <button
      pButton
      class="p-button-danger"
      icon="pi pi-trash"
      label="Delete Schedules"
      (click)="deleteSchedules()"
      [disabled]="!startDate() || !endDate()"
    ></button>
  }
</div>
